import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const ALLOWED_KEYS = ["BUSINESS_PREMIUM", "POLICIES_SOLD", "CLAIMS_ASSISTED"];

const normalizeStats = (apiData) => {
    if (!Array.isArray(apiData) || apiData.length === 0) return null;
    return apiData.filter((x) => ALLOWED_KEYS.includes(x?.dataKey));
};

const PublicDataStats = ({ className }) => {
    const [stats, setStats] = useState(null); // null = API response nahi aayi

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const res = await axios.get(
                    "/cdn/v1/publicdata"
                );
                const data = typeof res.data === "string"
                    ? JSON.parse(res.data)
                    : res.data;

                const normalized = normalizeStats(data);
                if (normalized && normalized.length > 0) {
                    setStats(normalized);
                }
            } catch (err) {
                console.error("Stats fetch failed:", err);
            }
        };
        fetchStats();
    }, []);

    const icons = useMemo(
        () => ({
            BUSINESS_PREMIUM: require("../Images/business-premium.svg").default,
            POLICIES_SOLD: require("../Images/policies-sold.svg").default,
            CLAIMS_ASSISTED: require("../Images/claims-assisted.svg").default,
        }),
        []
    );

    // stats null hai ya empty hai to kuch render mat karo
    if (!stats || stats.length === 0) return null;

    return (
        <div className={className ? `otherLinksSmc ${className}` : "otherLinksSmc"}>
            <div className="StepsRow">
                {stats.map((item) => (
                    <div className="StepsColm" key={item.dataKey}>
                        <img alt="" src={icons[item.dataKey]} />
                        <div>
                            <small>
                                {item.displayLabel}
                                <br />
                                <b>{item.dataValue}</b>
                            </small>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PublicDataStats;